import { useContext } from 'react';
import InviteValidationContext, {
  InviteValidationContextType,
} from '../contexts/InviteValidationContext';

const useInviteValidation = (): InviteValidationContextType => {
  const context = useContext(InviteValidationContext);
  if (context === undefined) {
    throw new Error(
      'useInviteValidation must be used within an InviteValidationProvider',
    );
  }

  return context;
};

export default useInviteValidation;
